import { useEffect } from "react"
import { $fundingPrograms, fetchFundingPrograms } from "./BusinessFundingPrograms.helpers";
import { Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const BusinessFundingPrograms = () => {
  useEffect(() => {
    fetchFundingPrograms();
  }, [])

  const fundingPrograms = $fundingPrograms.value.data;
  const mayQualifyFundingPrograms = $fundingPrograms.value.mayQualifyFundingPrograms;
  
  return (
    <Row className="px-xl-64">
      <Col>
        <Card className="px-24 px-lg-48 py-32 mx-xl-16">
          <h3 className="text-center">Funding Programs</h3>
          <hr />
          <Row>
            {fundingPrograms.map(fundingProgram => {
              const { heading, name, key } = fundingProgram;

              return (
                <Col key={key} xs={12} sm={6} md={4} className="mb-16">
                  <Card className="rounded-lg border-0">
                      <Card.Img 
                        variant="top" 
                        src={fundingProgram.headerImageUrl} 
                        style={{
                          objectFit: 'cover',
                          height: '300px',
                        }}
                      />
                    <Card.Body>
                      <Card.Title style={{ minHeight: '60px' }}>
                        <a href={`/business/funding-programs/${fundingProgram.id}`}>
                        {name}
                        </a>
                      </Card.Title>
                      <Card.Text style={{ minHeight: '200px' }}>{heading}</Card.Text>
                      {mayQualifyFundingPrograms.map(fp => fp.id).includes(fundingProgram.id) ?
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="text-success m-0 p-0">
                            Your business may qualify!
                          </p>
                          <Link
                            to={`/business/search/search-results?programName=${fundingProgram.id}`}
                            className="btn btn-link"
                          >
                            Find Lenders
                          </Link>
                        </div>
                      :
                        <div className="d-flex justify-content-end align-items-center">
                          <Link
                            to={`/business/search/search-results?programName=${fundingProgram.id}`}
                            className="btn btn-link"
                          >
                            Find Lenders
                          </Link>
                        </div>
                      }
                    </Card.Body>
                  </Card>
                </Col>
              )
            })}
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default BusinessFundingPrograms;
